<script>
    import { Icon, Funnel, MagnifyingGlass } from "svelte-hero-icons";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
    let keywords= ["Land Cover", "Glacier", "Glacial lake", "Hydropower", "Fire", "Population","Mountain"];
    export let showFilters = false;
  
    const toggleFilters = () => {
      showFilters = !showFilters;
    };
  
    const applyFilters = () => {
        // Logic to collect selected options
        const selectedKeywords = Array.from(
            document.querySelectorAll('input[type="checkbox"]:checked')
        ).map((checkbox) => checkbox.value);
        
        // console.log("Selected Keywords:", selectedKeywords);
        toggleFilters();
        dispatch("applyFilters", selectedKeywords);
    };

    const searchDatasets = () => {
        const searchTerm = document.querySelector('input[type="text"]').value;
        dispatch("searchDatasets", [searchTerm]);
    };
  </script>
  
  <div class="p-4 max-w-md mx-auto">
    <!-- Search Bar -->
    <div class="flex items-center bg-gray-200 rounded-lg shadow-md">
        <!-- Filter Icon -->
        <button
            class="p-3 bg-gray-200 rounded-l-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300"
            on:click={toggleFilters}
            aria-label="Toggle Filters"
        >
            <!-- <Filter class="h-6 w-6 text-gray-700" /> -->
            <Icon src={Funnel} size="18" />
        </button>
  
        <!-- Input Field -->
        <input
            type="text"
            placeholder="Search datasets"
            class="flex-1 px-4 py-2 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
            on:input={searchDatasets}
            />

        <!-- Search Icon -->
        <button class="p-3 bg-gray-300 rounded-r-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300" 
        aria-label="Search">
            <Icon src={MagnifyingGlass} size="18" />
        </button>
    </div>
  
    <!-- Filter Options -->
    <div
    class={`transition-all duration-300 overflow-hidden rounded-lg shadow-xl ${
        showFilters ? "max-h-96 mt-2" : "max-h-0"
    }`}
    >
        <form
            class="p-4 bg-white rounded-lg border border-gray-200 space-y-4 "
        >
            <p class="text-sm font-medium text-gray-700">Select Keywords:</p>
            <div class="space-y-2">
                <!-- Checkbox Options -->
                {#each keywords as keyword}
                    <label class="flex items-center space-x-2">
                        <input
                            type="checkbox"
                            value={keyword.toLowerCase()}
                            class="h-4 w-4 text-blue-500 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                        />
                        <span class="text-gray-700">{keyword}</span>
                    </label>
                {/each}
            </div>

            <button
            type="button"
            on:click={applyFilters}
            class="block w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600"
            >
            Apply Filters
            </button>
        </form>
    </div>

    
  </div>
  